import { render, staticRenderFns } from "./block-ai-generation-loader.vue?vue&type=template&id=11057e34&scoped=true&lang=pug"
import script from "./block-ai-generation-loader.vue?vue&type=script&lang=js"
export * from "./block-ai-generation-loader.vue?vue&type=script&lang=js"
import style0 from "./block-ai-generation-loader.vue?vue&type=style&index=0&id=11057e34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11057e34",
  null
  
)

export default component.exports